import { gql } from '@apollo/client'

export const GET_CREATOR_CENTER_OVERVIEW = gql`
  fragment artistStatisticsOverviewField on ArtistStatisticsOverview {
    newFans
    totalIncome
    artworkCount
    shareCount
    uid
  }
  query getCreatorCenterOverview {
    dayall: artistStatisticsOverview(param: { date: ALL_TIME }) {
      ...artistStatisticsOverviewField
    }
    day30: artistStatisticsOverview(param: { date: THIRTY_DAYS }) {
      ...artistStatisticsOverviewField
    }
    day14: artistStatisticsOverview(param: { date: FOURTEEN_DAYS }) {
      ...artistStatisticsOverviewField
    }
    day7: artistStatisticsOverview(param: { date: SEVEN_DAYS }) {
      ...artistStatisticsOverviewField
    }
    userinfo: copyrightUserInfo {
      avatarUrl
      nickname
      settledCreatorDay
      base {
        uid
        mobile
      }
    }
  }
`

export const GET_FOLLOWING_STATS = gql`
  fragment userField on CopyrightBaseUserInfo {
    avatarUrl
    nickname
    userRoleInfo {
      artist
      aiArtist
    }
    personalizedSignature
    uid
  }
  query getFollowingStats {
    day7_overview: artistFansStatistics(param: { date: SEVEN_DAYS }) {
      loseFans
      newFans
    }
    day30_overview: artistFansStatistics(param: { date: THIRTY_DAYS }) {
      loseFans
      newFans
    }
    day7_ranking: artistFansActiveRank(param: { date: SEVEN_DAYS }) {
      ...userField
    }
    day30_ranking: artistFansActiveRank(param: { date: THIRTY_DAYS }) {
      ...userField
    }
    userinfo: copyrightUserInfo {
      social {
        fansCount
      }
    }
  }
`

export const GET_PRODUCT_STATS = gql`
  fragment productField on Artwork {
    productUrl: artworkUrl
    name
    id
    meta: artworkSocialInfo {
      # favNum: collectsCountStr
      # likeNum: likesCountStr
      # viewNum: viewsCountStr
      fav: collectsCountStr
      like: likesCountStr
      view: viewsCountStr
    }
  }
  query getProductStats {
    itemModule {
      dayall_overview: artworkSocialInfosByArtist(param: ALL_TIME) {
        favoriteCount: collectsCount
        likesCount
        shareCount
        viewCount
      }
      day7_overview: artworkSocialInfosByArtist(param: SEVEN_DAYS) {
        favoriteCount: collectsCount
        likesCount
        shareCount
        viewCount
      }

      collection_overview: artworkSeriesSocialInfosByArtist {
        favoriteCount: collectsCount
        likesCount
        shareCount
        viewCount
      }

      day7_view_ranking: artworkViewLeaderboardByArtist(
        param: { dataType: SEVEN_DAYS }
      ) {
        ...productField
      }

      dayall_view_ranking: artworkViewLeaderboardByArtist(
        param: { dataType: ALL_TIME }
      ) {
        ...productField
      }

      day7_like_ranking: artworkLikeLeaderboardByArtist(
        param: { dataType: SEVEN_DAYS }
      ) {
        ...productField
      }

      dayall_like_ranking: artworkLikeLeaderboardByArtist(
        param: { dataType: ALL_TIME }
      ) {
        ...productField
      }

      day7_favorite_ranking: artworkCollectLeaderboardByArtist(
        param: { dataType: SEVEN_DAYS }
      ) {
        ...productField
      }

      dayall_favorite_ranking: artworkCollectLeaderboardByArtist(
        param: { dataType: ALL_TIME }
      ) {
        ...productField
      }
    }
  }
`

/** 获取特定作品集数据 */
export const GET_COLLECTION_STATS = gql`
  query getCollectionStats($id: Long) {
    itemModule {
      collection_overview: artworkSeriesSocialInfosByArtist(seriesId: $id) {
        favoriteCount: collectsCount
        likesCount
        shareCount
        viewCount
      }
    }
  }
`

export const GET_INCOME_STATS = gql`
  query getIncomeStats {
    artistIncomeStatistics {
      totalIncome
      walletAvailableBalance
      yesterDayIncome
    }

    day14_chart: artistIncomeStatisticsAnalysis(
      param: { date: FOURTEEN_DAYS }
    ) {
      bonusIncome
      copyrightRoyaltyIncome
      date
      firstSaleIncome
      totalIncome
    }

    itemModule {
      sell_ranking: artworkBestSellingLeaderboardByArtist {
        productUrl: artworkUrl
        name
        id
        meta: transactionInfo {
          count: tradCountStr
          income: artistIncomeStr
        }
      }
      income_ranking: artworkIncomeLeaderboardByArtist {
        productUrl: artworkUrl
        name
        id
        meta: transactionInfo {
          count: tradCountStr
          income: artistIncomeStr
        }
      }
    }
  }
`

export const COUNT_SHARE_PRODUCT = gql`
  mutation countShareProduct($param: SocialActionInput!) {
    itemModule {
      doArtworkShareAction(param: $param)
    }
  }
`

export const COUNT_VIEW_PRODUCT = gql`
  mutation countViewProduct($param: SocialActionInput!) {
    itemModule {
      doArtworkViewAction(param: $param)
    }
  }
`
